<template>
  <footer class="footer">
    <div class="footer__info">
      <div class="footer__info__inner">
        <h3 class="footer__info__title">導入を検討中の方へ</h3>
        <div class="footer__info__card">
          <p class="footer__info__text">プランの選択・運用など、気になることがあれば<br>まずはお気軽にご相談ください。</p>
          <div class="footer__info__btns">
            <nuxt-link class="button contact" to="/contact">お問い合わせ</nuxt-link>
            <nuxt-link class="button download" to="/resources">資料請求</nuxt-link>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="footerButton top">
      <h3>無料でお試し・資料請求</h3>
      <div class="buttons">
       <nuxt-link class="button trial" to="/auth/register">無料お試し</nuxt-link>
        <nuxt-link class="button download" to="/resources">資料をダウンロード</nuxt-link>
      </div>
    </div> -->
    <div class="footerLink">
      <img class="" src="/frontend/img/logo-c.svg" alt="会社手続きナビゲーター モチカケ">
      <div class="links">
        <div class="line">
          <nuxt-link to="/trade" class="">特定商取引法に基づく表記</nuxt-link>
          <nuxt-link target="_blank" to="/terms" class="">利用規約</nuxt-link>
          <nuxt-link target="_blank" to="/privacy" class="">プライバシーポリシー</nuxt-link>
          <a href="https://sample-text.co.jp/" target="_blank" class="">運営会社<i class="las la-external-link-alt"></i></a>
        </div>
        <div class="line">
          <nuxt-link to="/contact" class="">お問い合わせ</nuxt-link>
          <a href="https://intercom.help/admin-legalscript/ja" target="_blank" class="">ヘルプ<i class="las la-external-link-alt"></i></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'f-footer-lp-top'
}
</script>
